import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addSla: {
		id: 'servicedesk-sla-settings.empty-view.add-sla',
		defaultMessage: 'Add SLA',
		description: 'add a new sla button label',
	},
});
